import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@sm/wds-react';

import Ribbon from '~pricing/components/Ribbon';
import PackageCta from '~pricing/components/PackageCta';
import { RibbonTextOverridePropType } from '~pricing/lib/proptypes';

const PackageHeader = ({
  packageClassName,
  packageName,
  packageLabel,
  priceValue = null,
  priceUnit = null,
  byline = null,
  ribbonText = null,
  CtaOverride = null,
}) => (
  <header className="sm-package__header" data-testid="PackageHeader__Header">
    <Typography
      component="h1"
      variant="sectionTitle"
      className="sm-package__title"
      data-testid="PackageHeader__HeaderText"
    >
      {packageLabel}
    </Typography>
    <If condition={priceValue && priceUnit}>
      <Typography component="h2" variant="cardTitle" data-testid="PackageHeader__Price" className="sm-package__cost">
        <Typography component="span" variant="pageTitle" className="sm-package__cost-amount">
          {priceValue}
        </Typography>
        {priceUnit}
      </Typography>
    </If>
    <If condition={byline}>
      <Typography
        component={priceValue && priceUnit ? 'h3' : 'h2'}
        variant="body"
        className="sm-package__byline"
        data-testid="PackageHeader__Byline"
      >
        {byline}
      </Typography>
    </If>
    <If condition={CtaOverride}>
      <CtaOverride />
    </If>
    <If condition={!CtaOverride}>
      <PackageCta packageName={packageName} packageClassName={packageClassName} />
    </If>
    <If condition={ribbonText}>
      <Ribbon packageName={packageClassName}>{ribbonText}</Ribbon>
    </If>
  </header>
);

PackageHeader.propTypes = {
  packageClassName: PropTypes.string.isRequired,
  packageName: PropTypes.string.isRequired,
  packageLabel: PropTypes.string.isRequired,
  priceValue: PropTypes.string,
  priceUnit: PropTypes.string,
  byline: PropTypes.string,
  ribbonText: RibbonTextOverridePropType,
  CtaOverride: PropTypes.func,
};

PackageHeader.defaultProps = {
  priceValue: null,
  priceUnit: null,
  byline: null,
  ribbonText: null,
  CtaOverride: null,
};

export default PackageHeader;
